export default __webpack_public_path__ + "static/real-time-data-updates-e3013c2ca0ef9dc436a449d7cb08d74e.png";